import { CdkScrollable } from '@angular/cdk/scrolling';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { RecoverFooterComponent } from 'app/shared/components/recover-footer/recover-footer.component';
import { RecoverHeaderComponent } from 'app/shared/components/recover-header/recover-header.component';

@Component({
    selector: 'recover-layout',
    standalone: true,
    imports: [
        RecoverHeaderComponent,
        RecoverFooterComponent,
        RouterOutlet,
        CdkScrollable,
    ],
    templateUrl: './recover-layout.component.html',
})
export class RecoverLayoutComponent {}
